import { Capacitor } from '@capacitor/core';

export const getAppUpdateUrl = () => {
  const platform = Capacitor.getPlatform();
  if (platform === 'web') {
    return import.meta.env.VITE_APP_URL;
  } else if (platform === 'ios') {
    return 'https://apps.apple.com/pl/app/voizor-sales/id6477194074';
  } else if (platform === 'android') {
    return 'https://play.google.com/store/apps/details?id=com.voizor.ai';
  }
};
